import React from 'react';
import { Link } from 'react-router-dom';
import { Settings as SettingsIcon, Receipt, Server, ExternalLink } from 'lucide-react';
import ProxySettings from './ProxySettings';
import ComingSoonSettings from './ComingSoonSettings';
import HotelSearchSettings from './HotelSearchSettings';
import SecuritySettings from './SecuritySettings';
import PublicUrlsSettings from './PublicUrlsSettings';
import SeoMigrationSettings from './SeoMigrationSettings';
import AdminPushOptIn from '../../components/admin/AdminPushOptIn';

const AdminSettings = () => {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
          <SettingsIcon className="w-8 h-8 text-[#659A9B]" />
          System Settings
        </h1>
        <p className="text-gray-600 mt-2">
          Site feature toggles and outbound proxy configuration
        </p>
      </div>

      <div className="mb-8">
        <AdminPushOptIn />
      </div>

      {/* Quick links to other settings pages */}
      <div className="grid md:grid-cols-2 gap-4 mb-8">
        <Link
          to="/admin/gst-settings"
          className="flex items-center gap-3 p-4 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-[#659A9B] hover:shadow-md transition-all group"
        >
          <div className="w-10 h-10 rounded-lg bg-[#659A9B]/15 flex items-center justify-center flex-shrink-0">
            <Receipt className="w-5 h-5 text-[#659A9B]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-gray-900 group-hover:text-[#1B375B]">GST &amp; Invoicing</p>
            <p className="text-sm text-gray-600">Company legal details, invoice numbering, bank details</p>
          </div>
          <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-[#659A9B] flex-shrink-0" />
        </Link>
        <Link
          to="/admin/supplier-settings"
          className="flex items-center gap-3 p-4 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-[#659A9B] hover:shadow-md transition-all group"
        >
          <div className="w-10 h-10 rounded-lg bg-[#659A9B]/15 flex items-center justify-center flex-shrink-0">
            <Server className="w-5 h-5 text-[#659A9B]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-gray-900 group-hover:text-[#1B375B]">Supplier Settings</p>
            <p className="text-sm text-gray-600">Tripjack, Riya, Razorpay, and SMTP credentials</p>
          </div>
          <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-[#659A9B] flex-shrink-0" />
        </Link>
      </div>

      {/* Outbound Proxy (QuotaGuard) */}
      <ProxySettings />

      {/* Security toggles (OTP dev echo, etc.) */}
      <SecuritySettings />

      {/* Public URLs (frontend/backend base for emails, payments, WhatsApp) */}
      <PublicUrlsSettings />

      {/* SEO Data Migration (export/import bundles between environments) */}
      <SeoMigrationSettings />

      {/* Coming soon — saves independently */}
      <ComingSoonSettings />

      {/* Hotel search visibility — saves independently */}
      <HotelSearchSettings />
    </div>
  );
};

export default AdminSettings;
